import { db } from '../firebase';
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  doc,
  setDoc,
  Timestamp,
  increment
} from 'firebase/firestore';

const ADMIN_EMAILS = ['info@tronapazarlama.com'];

// ✅ Kullanıcı tipi için summary güncelle
export const updateUserTypeSummary = async (userType, userEmail = null) => {
  console.log('═══════════════════════════════════');
  console.log('💾 updateUserTypeSummary ÇAĞRILDI');
  console.log('UserType:', userType);
  console.log('UserEmail:', userEmail || 'NULL');
  
  try {
    // ✅ Admin kontrolü
    if (userEmail && ADMIN_EMAILS.includes(userEmail.toLowerCase())) {
      console.log('🔒 ADMIN EMAIL - Summary güncellenmedi');
      console.log('═══════════════════════════════════');
      return { success: true, skipped: true };
    }

    const date = new Date().toISOString().split('T')[0];
    const summaryRef = doc(db, 'visitor_summary', date);
    
    console.log('📅 Tarih:', date);
    console.log('📝 Firestore path:', `visitor_summary/${date}`);
    
    // ✅ DOĞRU SYNTAX - Nested object
    const updateData = {
      date,
      lastUpdated: Timestamp.now(),
      userTypes: {
        [userType]: increment(1)
      }
    };
    
    console.log('📝 Update Data:', updateData);
    
    await setDoc(summaryRef, updateData, { merge: true });

    console.log('✅ Firestore\'a yazıldı!');
    console.log('═══════════════════════════════════');
    return { success: true };
  } catch (error) {
    console.error('❌ Summary güncelleme hatası:', error);
    console.log('═══════════════════════════════════');
    return { success: false, error: error.message };
  }
};

// ✅ Kullanıcı tipi istatistikleri al
export const getUserTypeStats = async (days = 30) => {
  console.log('═══════════════════════════════════');
  console.log('📊 getUserTypeStats ÇAĞRILDI');
  console.log('Days:', days);
  
  try {
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - days);
    const startDateStr = startDate.toISOString().split('T')[0];

    console.log('📅 Start Date:', startDateStr);
    console.log('📅 Today:', today.toISOString().split('T')[0]);

    const summaryRef = collection(db, 'visitor_summary');
    const q = query(
      summaryRef,
      where('date', '>=', startDateStr),
      orderBy('date', 'desc')
    );

    const snapshot = await getDocs(q);
    console.log('📄 Snapshot size:', snapshot.size, 'documents');

    const userTypes = { registered: 0, guest: 0 };

    snapshot.docs.forEach(docSnap => {
      const data = docSnap.data();
      console.log('📄 Document:', docSnap.id, data);
      
      // ✅ DOĞRU OKUMA - userTypes objesi içinden
      if (data.userTypes) {
        userTypes.registered += data.userTypes.registered || 0;
        userTypes.guest += data.userTypes.guest || 0;
      }
    });

    const total = userTypes.registered + userTypes.guest;
    const conversionRate = total > 0 
      ? ((userTypes.registered / total) * 100).toFixed(1)
      : '0.0';

    console.log('✅ User Type Stats:', { userTypes, total, conversionRate });
    console.log('═══════════════════════════════════');

    return { 
      success: true, 
      userTypes,
      total,
      conversionRate
    };
  } catch (error) {
    console.error('❌ User type stats hatası:', error);
    console.log('═══════════════════════════════════');
    return { success: false, error: error.message };
  }
};